import { IPeopleInfo } from '../interfaces/IPeopleInfo';

import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';

export default class PhonebookService {

  public static getPhonebook(url: string, token: string): Promise<{ people: IPeopleInfo[], searchQuery: string, status: number } | null> {
    return new Promise((resolve) => {
      if (token && url) {
        return new FetchProxy(url, {
          method: 'GET',
          credentials: 'same-origin',
          mode: 'cors',
          headers: new Headers({
            AuthToken: token
          })
        })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response: Response) => {
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
          })
          .then((phonebook) => {
            resolve({ people: phonebook.people, searchQuery: phonebook.searchQuery ?? "", status: 200 });
          })
          .catch((error) => {
            console.log(error);
            resolve({ people: [], searchQuery: "", status: error.status || 500 });
          });
      } else {
        resolve(null);
      }
    });
  }
}
